export const defaultActionList = () => [
    {
        id: 1,
        name: 'Visualizar dados do Cliente',
        action: 'redirect--client',
        check: false,
    },
    {
        id: 2,
        name: 'Criar uma Tarefa',
        action: 'redirect--make-task',
        check: false,
    },
    {
        id: 3,
        name: 'Solicitar uma nova Reserva',
        action: 'redirect--make-reserve',
        check: false,
    },
]